module.exports = __webpack_public_path__ + "img/cases-brand-hla-11.43ecdfc2.png";